import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Order } from '../models/order.model';
import { ReservationRoom } from '../models/reservationRoom.model';
import { Client } from '../models/client.model';

@Injectable({
  providedIn: 'root'
})
export class ReservationSearchService {
  private reservationSubject = new BehaviorSubject<any>(null);
  selectedClient: any;
  clientSelected: any;
  Order: Order;
  pricTotal: number;
  chosenRooms: any;
  checkinDate: string;
  Checkout: string;
  passengers : any[] = [];
  spinner: boolean;
  product: any;
  reservations:  ReservationRoom [] = [];
  dateArriver:any;
  dateDepart:any;
  NumberOfNeight:number=0;
  Rooms:any[] =[];
  clientId:any; 
  segment:any;
  reserva:any;
  Client:Client = undefined;
  forcedReservation:boolean = false;
  canal:any;
  SegmentName:any = undefined;
  SegmentNameID:any = undefined;
  creationDate: string;

  constructor() { }

  onChangeReservation(): Observable<any>{
    return this.reservationSubject.asObservable();
  }

  
  changeReservation(reservation: any){
    this.reservationSubject.next(reservation);
  }
 

}
